import Link from "next/link";

import RichContent from "components/app/RichContent";
import UserAvatar from "components/user/UserAvatar";

import { timeAgo } from "utils/app";
import { postUrl, getHref } from "utils/route";

const UserCommentItem = ({ comment }: { comment: any }) => {
  const post = {
    id: comment.post_id,
    category_code: comment.talent ? "talent" : "",
  };
  return (
    <div className="post-item">
      <div className="aside">
        <UserAvatar user={comment.user} size={undefined} />
      </div>
      <div className="body">
        <div className="flex">
          <div>{timeAgo(comment.published_at)}</div>
          <div className="ml-10">点赞：{comment.votes_count}</div>
        </div>
        <RichContent className="my-10" html={comment.content} />
        <div>
          <Link legacyBehavior href={getHref(post)} as={postUrl(post)}>
            <a target="_blank" className="flex text-primary">
              <div className="mr-10">来自:</div>
              <div>{comment.post_title}</div>
            </a>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default UserCommentItem;
